module.exports = __webpack_public_path__ + "static/media/img_main.70b0430c.png";